import { client } from "../client";
import type { Variant } from "../types/earmold.types";

export const updateVariant = async ({
	id,
	variant,
}: {
	id: number | string | undefined;
	variant: Partial<Variant>;
}) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.patch<Variant>(`variants/${id}/`, variant);
	return response.data;
};
